import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { ucFirst } from '../../../helpers/string_helper';

const SelectDropdown = ({label, disabled, list, emitSelectedValue, className, style}) => {
    const [isDropdown, setIsDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    
    const toggleDropdown = () => {
        setIsDropdown(!isDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown size='small' isOpen={isDropdown} toggle={toggleDropdown} className="topbar-head-dropdown header-item" disabled={disabled ?? false}>
                <DropdownToggle caret={!disabled} className={className ? className : "drop_button"} style={style}>
                    {selectedOption !== null  ? ucFirst(selectedOption.name) : `${label}`}
                </DropdownToggle>
                <DropdownMenu className="notify-item language py-2">
                    {list.map((_l, index) => (
                        <DropdownItem
                            key={`${_l.name} - ${_l.id} - ${index}`}
                            onClick={() => { 
                                setSelectedOption(_l)
                                emitSelectedValue(_l)
                            }}
                            className={`notify-item ${ selectedOption?.id === _l.id ? "active" : "none"
                                }`}
                        >
                            <span className="align-middle">
                                {ucFirst(_l.name)}
                            </span>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default SelectDropdown;